import React, {useMemo} from 'react';
import { Box } from '@mui/joy';
import { KPI } from '../../../../mtska-frontend-app-component';
import List from './List';

const Default = () => {

    return <>
        {/* <Box className="mtksa-chart-wrapper">
            <KPI
                title="Vehicles"
                icon="faCar"
                dataProviderName={'statistics/item/count/cars/car'}
            />
            <KPI
                title="Employments"
                icon="faCar"
                dataProviderName={'statistics/item/count/persons/employment'}
            />
        </Box> */}
        <List />
    </>

}

export default Default;


